import { graphql } from "gql";

const INTERNAL_ADMIN_EDIT_DISTRIBUTION_GROUP_MUTATION = graphql(`
  mutation InternalAdminEditDistributionGroup(
    $organizationId: ID!
    $id: ID!
    $input: AdminEditDistributionGroupInput!
  ) {
    internalAdminEditDistributionGroup(
      organizationId: $organizationId
      id: $id
      input: $input
    ) {
      ...InternalAdminDistributionGroup
    }
  }
`);

export default INTERNAL_ADMIN_EDIT_DISTRIBUTION_GROUP_MUTATION;
